import { FormattedAxnAdminSession } from "@idw-types/data/management-console/axnadmin";

export enum AxnAdminSessionsActionTypes {
    SET_AXN_ADMIN_SESSIONS_LOADING = "SET_AXN_ADMIN_SESSIONS_LOADING",
    SET_AXN_ADMIN_SESSIONS = "SET_AXN_ADMIN_SESSIONS"
}

type SetAxnAdminSessionsLoadingAction = {
    type: AxnAdminSessionsActionTypes.SET_AXN_ADMIN_SESSIONS_LOADING,
    payload: { isLoading: boolean; }
};

export const setAxnAdminSessionsLoading = (isLoading: boolean): SetAxnAdminSessionsLoadingAction => ({
    type: AxnAdminSessionsActionTypes.SET_AXN_ADMIN_SESSIONS_LOADING,
    payload: { isLoading }
});

type SetAxnAdminSessionsAction = {
    type: AxnAdminSessionsActionTypes.SET_AXN_ADMIN_SESSIONS,
    payload: { axnAdminSessions: Array<FormattedAxnAdminSession>; }
}

export const setAxnAdminSessions = (axnAdminSessions: Array<FormattedAxnAdminSession>): SetAxnAdminSessionsAction => ({
    type: AxnAdminSessionsActionTypes.SET_AXN_ADMIN_SESSIONS,
    payload: { axnAdminSessions }
});

export type AxnAdminSessionsActions =
    SetAxnAdminSessionsLoadingAction |
    SetAxnAdminSessionsAction